import { RootState } from 'types'
import { Action } from 'redux/actions'

export default function reduce(
  state: RootState['floatingSidebar'] = false,
  action: Action,
): RootState['floatingSidebar'] {
  switch (action.type) {
    case 'FLOATING_SIDEBAR_SET': {
      return action.payload
    }

    default:
      return state
  }
}
